import { ref, defineComponent, onMounted, onBeforeMount, computed, watch } from "vue";
import { postRequest } from "@/assets/utils/utils";
import InputText from "primevue/inputtext";
import Button from "primevue/button";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
export default defineComponent({
  name: "RoleTable",
  components: {
    InputText,
    Button,
    DataTable,
    Column
  },
  props: {
    currentRole: {
      type: Object
    }
  },

  setup(props, context) {
    // 查询参数
    let queryParam = ref({}); // 分页

    let currentPage = ref(1);
    let pageSize = ref(10);
    let total = ref(0); // 行数据

    let rows = ref([]); // 选中的行数据
    // 选中的行数据

    let selectedRow = ref(null);
    let current_role = computed({
      get: () => {
        return props.currentRole;
      },
      set: v => {
        context.emit('update:currentRole', v);
      }
    }); // eslint-disable-next-line

    watch(selectedRow, (newVal, oldVal) => {
      current_role.value = newVal;
    });
    onBeforeMount(() => {
      init_query_param();
    });
    onMounted(() => {
      load_all_data();
    }); // 初始化查询参数

    function init_query_param() {
      queryParam.value = {
        role_name: null,
        role_desc: null
      };
    } // 使用查询参数载入数据


    function load_data() {
      postRequest('/qytenantorg_api/sysset/find_roles?current_page=' + currentPage.value + '&page_size=' + pageSize.value, queryParam.value).then(response => {
        total.value = response.data.total;
        rows.value = response.data.datas;
        selectedRow = null;
      });
    } // 查询按钮单击事件


    function load_query_data() {
      currentPage.value = 1;
      load_data();
    } // 全部按钮单击事件


    function load_all_data() {
      init_query_param();
      currentPage.value = 1;
      load_data();
    } // 页尺寸改变时事件


    function page_size_changed(size) {
      pageSize.value = size;
      load_all_data();
    } // 当前页改变时事件


    function current_page_changed(page) {
      currentPage.value = page;
      load_data();
    }

    return {
      queryParam,
      currentPage,
      pageSize,
      total,
      rows,
      selectedRow,
      load_query_data,
      load_all_data,
      page_size_changed,
      current_page_changed
    };
  }

});